// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2H-zY","location":"Header_location__1d_6X"};